import { VueConstructor } from 'vue';

// Shared utils
import { CurrencyFormatter } from '@stooseflow/utils-front';

/**
 *
 *  Used to install the application's filters.
 *
 *  @param Vue The Vue instance to install the filters for
 *
 */
export default function InstallFilters(Vue: VueConstructor): void {

    Vue.filter('currency', CurrencyFormatter);

}
